export default __webpack_public_path__ + "static/media/landingherobook2.640a4629.png";